import React, { useState, useEffect } from "react";
import { ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { Dialog } from "@mui/material";
import { Input } from "@vds/inputs";
import { Icon } from "@vds/icons";
import { DropdownSelect } from "@vds/selects";
import {
  Accordion,
  AccordionDetail,
  AccordionHeader,
  AccordionItem,
  AccordionSubTitle,
  AccordionTitle,
} from "@vds/accordions";
import {
  fetchNotificationGroupsEndPoint,
  fetchNotificationUsersEndPoint,
} from "../../../configuration";
import { useSelector } from "react-redux";
import axiosInstance from "../../axiosInterceptor";

const ShareEvents = ({
  showShareEvents,
  setShowShareEvents,
  setUnNotifiedGroups,
  unNotifiedGroups,
  userList,
  setUserList,
}) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const [shareEventsNotes, setShareEventsNotes] = useState("");
  const [shareEventsGroups, setShareEventsGroups] = useState("");

  // const [unNotifiedGroups, setUnNotifiedGroups] = useState([]);
  // const [userList, setUserList] = useState([]);
  const [notifiedGroups, setNotifiedGroups] = useState([]);

  useEffect(() => {
    const notifiedGroups = [
      // {
      //   name: "Security team A",
      //   associatedUsers: [
      //     { name: "James Franci", number: "123-456-7890" },
      //     { name: "Marin Septimus", number: "123-456-7890" },
      //   ],
      // },
      // {
      //   name: "SFO Demo",
      //   associatedUsers: [{ name: "James Franci", number: "123-456-7890" }],
      // },
      // {
      //   name: "Security team C",
      //   associatedUsers: [{ name: "Marin Septimus", number: "123-456-7890" }],
      // },
    ];
    setNotifiedGroups([...notifiedGroups]);

    const loadNotificationUsers = async () => {
      const response = await axiosInstance.post(
        fetchNotificationUsersEndPoint(),
        {
            accountName: activeSession.accountId,
        }
      );
      let notificationUsersResponse = response?.ok ? response.data : [];
      if (notificationUsersResponse?.length) {
        return notificationUsersResponse;
      } else {
        return [];
      }
    };
    const loadUnNotifiedGroups = async () => {
      const response = await axiosInstance.post(
        fetchNotificationGroupsEndPoint(),
        {
            accountName: activeSession.accountId,
        }
      );
      let notificationGroupResponse = response?.ok ? response.data : [];
      if (notificationGroupResponse?.length) {
        notificationGroupResponse = notificationGroupResponse
          ?.filter(
            (group) => !notifiedGroups.some((item) => item.name === group?.name)
          )
          ?.map((group) => {
            return { ...group, isGroup: true, notifierName: group?.name };
          });
        let userList = await loadNotificationUsers();
        userList = [
          ...userList?.map((user) => {
            return {
              ...user,
              notifierName: `${user?.firstname} ${user?.lastname}`,
              isGroup: false,
            };
          }),
        ];
        setUserList([...userList]);
        setUnNotifiedGroups([...notificationGroupResponse]);
      }
    };
    if (userList !== undefined) {
      loadUnNotifiedGroups();
    }
  }, []);

  return (
    <>
      <Dialog
        aria-label="Resolve event modal"
        fullWidthh={true}
        maxWidth={"xl"}
        open={showShareEvents?.isOpen}
        disableOutsideClick={true}
        surface="light"
      >
        <div style={{ margin: "2%" }}>
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "20px",
              top: "20px",
            }}
            onClick={(e) => {
              setShowShareEvents({ isOpen: false });
            }}
          >
            <Icon name="close" />
          </div>
          <div style={{ display: "flex", margin: "3%" }}>
            <div
              style={{ borderRight: "1px solid #D8DADA", paddingRight: "20px" }}
            >
              <ModalTitle>
                <Title size="medium" bold>
                  Share with additional people
                </Title>
              </ModalTitle>

              <ModalBody>
                <DropdownSelect
                  label="Contact group/individuals"
                  defaultValue={shareEventsGroups}
                  onChange={(e) => setShareEventsGroups(e.target.value)}
                >
                  <option></option>
                  {[...(unNotifiedGroups || []), ...(userList || [])].map(
                    (userGroup) => (
                      <option key={userGroup?.notifierName}>
                        {userGroup?.notifierName}{" "}
                        {userGroup?.isGroup ? " (G)" : " (U)"}
                      </option>
                    )
                  )}
                </DropdownSelect>
                <br />
                <Input
                  label="Notes"
                  defaultValue={shareEventsNotes}
                  onChange={(e) => {
                    setShareEventsNotes(e.target.value);
                  }}
                />
              </ModalBody>
              <ModalFooter
                buttonData={{
                  primary: {
                    width: "100%",
                    children: "Share",
                    disabled:
                      !shareEventsNotes?.trim() || !shareEventsGroups?.trim(),
                    onClick: () => {
                      setShowShareEvents({ isOpen: false });
                    },
                  },
                }}
              />
            </div>
            <div style={{ paddingLeft: "20px" }}>
              <div style={{ marginBottom: "10px" }}>
                <Title size="small" bold>
                  Notified groups
                </Title>
              </div>
              <Body size="large">
                Groups that have already been notified of this event.
              </Body>
              {notifiedGroups?.length > 0 ? (
                <div
                  style={{
                    maxHeight: "380px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    marginTop: "10px",
                  }}
                >
                  <Accordion>
                    {notifiedGroups?.map((group) => {
                      return (
                        <AccordionItem key={group?.name}>
                          <AccordionHeader triggerType="icon">
                            <AccordionTitle>
                              <Title size="small">{group?.name}</Title>
                            </AccordionTitle>
                          </AccordionHeader>
                          <AccordionDetail>
                            {group?.associatedUsers?.map((item) => {
                              return (
                                <div key={item?.name}>
                                  <Body>{item?.name}</Body>
                                  <Body color="gray">{item?.number}</Body>
                                  <br />
                                </div>
                              );
                            })}
                          </AccordionDetail>
                        </AccordionItem>
                      );
                    })}
                  </Accordion>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "200px",
                  }}
                >
                  <Title size="medium">No groups found</Title>
                </div>
              )}
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ShareEvents;
